import ls from 'local-storage';

const TOKEN_KEY = 'token';
const MFA_TOKEN_KEY = 'mfaSessionToken';

export const getToken = () => ls.get(TOKEN_KEY);

export const setToken = token => ls.set(TOKEN_KEY, token);

export const getMfaSessionToken = () => ls.get(MFA_TOKEN_KEY);
export const setMfaSessionToken = token => ls.set(MFA_TOKEN_KEY, token);
export const removeMfaSessionToken = () => ls.remove(MFA_TOKEN_KEY);
